import dataConfig from '../config';
export const ALPHABET = [
  'Tous',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

export const SITEARO =
  'https://aro-digital.atlassian.net/servicedesk/customer/portals';

export const PRIVACY = `Vous devez accepter la ${dataConfig.privacyURL} pour continuer`;
